export default {
  "modal": {
    "developer": {
      "error": {
        "keyring_locked": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keyring is locked. Please, relaunch extension."])}
      }
    }
  },
  "external": {
    "settings": {
      "menu_item_profiles_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Profiles"])},
      "menu_item_import_recover_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Import & recover"])}
    }
  },
  "create_address": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Requests a profile address"])},
    "happy_with_address": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Happy with your Universal Profile Address?"])},
    "description": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["This app requires an address generated according to the <span style=\"cursor: pointer; font-weight: bold; text-decoration-line: underline;\">", _interpolate(_named("lsp23")), "</span> multi chain standard."])},
    "confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm address"])}
  },
  "confirmation": {
    "key_usage": {
      "transaction_fee_to_balance_separator": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" of "])},
      "progress_label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("estimatedGas")), " of ", _interpolate(_named("balance"))])}
    }
  },
  "activity": {
    "event": {
      "siwe": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SIWE"])},
      "ContractDeployment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contract Deployment"])}
    }
  }
}